import { connect } from 'react-redux';

import { requestFilters } from "store/filters/actions";
import { getAllFilters, isInitialized } from 'store/filters/selectors';

import { SearchOptionScreen } from "./SearchOptionScreen";

const mapStateToProps = (state) => ({
  isInitialized: isInitialized(state), 
  filters: getAllFilters(state),  
}); 

const mapDispatchToProps = dispatch => ({
  fetchFilters: () => dispatch(requestFilters()),
});

export const SearchOptionScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchOptionScreen);
